import Utils from '../../services/Utils'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const ReportAccessApi = {
  get: async function (groupId, cancel = false) {
    const response = await GApi.request({
      url: '/global-reporting/report-access/' + groupId,
      method: 'GET',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(ReportAccessApi)
export default ReportAccessApi
